/** Źródła pochodzą z zapisanego odczytu, także gdy użytkownik poprawił wartość. */
export function recipientSources(candidate) {
  if (candidate.sources?.length) return candidate.sources;
  return candidate.documentId
    ? (candidate.pages?.length ? candidate.pages : [undefined]).map((page) => ({
        documentId: candidate.documentId,
        ...(page ? { page } : {}),
      }))
    : [];
}

export function sourceContext(order, params) {
  const itemId = params.get("item");
  if (itemId) {
    const item = order.draft.items.find((entry) => entry.id === itemId);
    return item
      ? {
          title: "Źródło odczytu pozycji",
          sources: item.sources || [],
          returnHash: `premium-item-${itemId}`,
        }
      : null;
  }
  const index = Number(params.get("recipient"));
  if (params.has("recipient") && Number.isInteger(index) && index >= 0) {
    const candidate = order.draft.recipientCandidates[index];
    return candidate
      ? {
          title: `Źródło odbiorcy · ${candidate.label}`,
          sources: recipientSources(candidate),
          returnHash: "premium-recipients",
        }
      : null;
  }
  return null;
}
